import { apiCall } from './_helper';

// Used for displaying planned maintenance message
// Tested and working: 4/6/2025
export const getMaintenance = async () => {
  return await apiCall({
    url: 'maintenance/maintenance',
    notJSON: true,
  });
};

// Used for displaying maintenance message on the landing page
// Tested and working: 4/6/2025
export const getAppMaintenance = async () => {
  return await apiCall({
    url: 'maintenance/appMaintenance',
    notJSON: true,
  });
};
